import { useProperty, useTranslation } from '@eti/providers';
import { Stack, Text, textVariants } from '@etg/wings';
import { Link } from 'react-router-dom';
import { isAfter } from 'date-fns';
import { useMemo } from 'react';
import TopicsContentWrapper from '../TopicsContentWrapper';
import CardWithActionButton from '../../common/CardWithActionButton';
import { routes } from '../../../../../constants/routesAndApisConstants';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import FaqSection from '../../common/FaqSection';

const Cancellation = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { cancellationOptionsData, faqSectionPerSlug } = useOrderDetails();
  const faqSectionSlug = p('ContactUs.Cancellation.Faq.Slug');

  const hasCancellationOptions = useMemo(() => {
    if (!cancellationOptionsData) {
      return false;
    }
    const hasNonExpiredOffers = cancellationOptionsData.cancellationOptions.refundOffers?.some(
      (refundOffer) => isAfter(refundOffer.expirationDateTimeUTC, new Date().toISOString()),
    );

    return (
      hasNonExpiredOffers ||
      cancellationOptionsData.cancellationOptions.includedCancellationProducts.length > 0
    );
  }, [cancellationOptionsData]);

  const leftColumnContent = hasCancellationOptions
    ? t('ContactUs.Subtopic.Cancellation.SelfService.Content')
    : t('ContactUs.Subtopic.Cancellation.NotSelfService.Content');

  return (
    <TopicsContentWrapper
      chatType="oriana"
      leftColumnContent={
        <Stack spacing={24}>
          <Text asHtml>{leftColumnContent}</Text>
          {faqSectionPerSlug?.[faqSectionSlug] && (
            <FaqSection
              headingAs="h5"
              headingLevel={4}
              padding={0}
              section={faqSectionPerSlug[faqSectionSlug]}
            />
          )}
        </Stack>
      }
      rightColumnContent={
        hasCancellationOptions && (
          <CardWithActionButton
            as={Link}
            buttonText={t('ContactUs.Subtopic.Cancellation.Banner.Button.Text')}
            to={routes.ORDER_DETAILS_MANAGE_TRIP}
          >
            <Stack spacing={8}>
              <Text variant={textVariants._16_BOLD}>
                {t('ContactUs.Subtopic.Cancellation.Banner.Title')}
              </Text>
              <Text>{t('ContactUs.Subtopic.Cancellation.Banner.Content')}</Text>
            </Stack>
          </CardWithActionButton>
        )
      }
      shouldShowContactMethods={!hasCancellationOptions}
      snowplowProperty="CANCELLATION"
    />
  );
};

export default Cancellation;
